<div class="select-layout" *ngIf="isLoadData">

  <div class="row mt-4 mb-3">
    <div class="col-3">
      <div class="dropdown-border pointer-link" style="position: relative;">
        <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'" [ngbPopover]="popContentBuildingName"
          triggers="manual" #p="ngbPopover" (click)="openPopover(p);enterName('buildingName')"
          (blur)="enterName('buildingName')" placement="bottom" popoverClass='dash-popover dashboard-popover'>
          <input class="pt-3 pb-3 pl-4 textbox-style placeholder-text pointer-link"
            [placeholder]="!buildingName ? 'Building Name' : ''" readonly
            [ngModel]="selectedBuidling|dropdownTextLimiter:selectedBuidling:parkBuilding"
            (ngModelChange)="selectedBuidling=$event" required>
          <label *ngIf="buildingName" class="form-lable-dropdown">Building Name</label>

          <img src="../../../assets/images/Path.png" class="dropdown-icon" loading="lazy" />
        </div>
      </div>

      <ng-template #popContentBuildingName>
        <div class="dashboard-popover">
          <div class="d-flex justify-content-between">
            <div class="pl-3 pt-3 pr-3 pb-3 " style="width: 100%;">
              <div class="row pb-2" *ngFor="let item of parkBuilding;let index =i"
                (click)="setBuildingName(item, 'click'); openPopover(p)" style="justify-content: space-between;">
                <div class="popover-content normal-font pl-3 email-width">
                  {{item.parkBuildingName}}
                </div>
                <div style="margin-right: 10px;">
                  <img src="assets/images/company/tick.png" *ngIf="item.checked">
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>

    <div class="col-3">
      <div class="dropdown-border pointer-link" style="position: relative;">
        <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'" [ngbPopover]="popEmpContent"
          triggers="manual" #pe="ngbPopover" (click)="openPopover(pe);enterName('empType')" placement="bottom"
          popoverClass='dash-popover dashboard-popover'>
          <input class="pt-3 pb-3 pl-4 textbox-style placeholder-text pointer-link"
            [placeholder]="!empType? 'Employee Type' : ''" readonly
            [ngModel]="selectedEmpType|dropdownTextLimiter:selectedEmpType:empTypes"
            (ngModelChange)="selectedEmpType=$event">
          <label *ngIf="empType" class="form-lable-dropdown">Employee Type</label>

          <img src="../../../assets/images/Path.png" class="dropdown-icon" loading="lazy" />
        </div>
      </div>

      <ng-template #popEmpContent>
        <div class="dashboard-popover">
          <div class="d-flex justify-content-between">
            <div class="pl-3 pt-3 pr-3 pb-3 " style="width: 100%;">
              <div class="row pb-2" *ngFor="let item of empTypes;let index =i"
                (click)="setEmpType(item, 'click'); openPopover(pe)" style="justify-content: space-between;">
                <div class="popover-content normal-font pl-3 email-width">
                  <img [src]="item.image">{{item.name}}
                </div>
                <div style="margin-right: 10px;">
                  <img src="assets/images/company/tick.png" *ngIf="item.checked">
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>

    <div class="col-3" *ngIf="empTypes[1].checked">

      <div class="dropdown-border pointer-link" style="position: relative;">
        <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'" [ngbPopover]="popInviteContent"
          triggers="manual" #pi="ngbPopover" (click)="openPopover(pi);enterName('invRights')" placement="bottom"
          popoverClass='dash-popover dashboard-popover'>
          <input class="pt-3 pb-3 pl-4 textbox-style placeholder-text pointer-link"
            [placeholder]="!invRights ? 'VMS Invitation Right' : ''" readonly
            [ngModel]="selectedRights|dropdownTextLimiter:selectedRights:inviteRights"
            (ngModelChange)="selectedRights=$event">
          <label *ngIf="invRights" class="form-lable-dropdown">VMS Invitation Right</label>

          <img src="../../../assets/images/Path.png" class="dropdown-icon" loading="lazy" />
        </div>
      </div>

      <ng-template #popInviteContent>
        <div class="dashboard-popover">
          <div class="d-flex justify-content-between">
            <div class="pl-3 pt-3 pr-3 pb-3 " style="width: 100%;">
              <div class="row pb-2" *ngFor="let item of inviteRights;let index =i"
                (click)="setInviteRights(item, 'click'); openPopover(pi);" style="justify-content: space-between;">
                <div class="popover-content normal-font pl-3 email-width">
                  {{item.name}}
                </div>
                <div style="margin-right: 10px;">
                  <img src="assets/images/company/tick.png" *ngIf="item.checked">
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>

    <div class="col-1"></div>

    <!-- <div class="col-2">
      <button routerLink="/company/employees/add-employee">Add Employee</button>
    </div> -->

  </div>
</div>


<div class="row search-input" *ngIf="isLoadData">
  <div class="col-12"><img src="../../../../assets/images/search.png"><input type="text"
      placeholder="Type here to search…" [(ngModel)]="searchText" (keyup)="getEmployeeByFilter()"></div>
</div>

<div class="active-layout" *ngIf="isLoadData">
  <div class="row pr-4">
    <div class="col-9 text pt-3">{{list?.length}} employees</div>

    <div class="col-3 d-flex justify-content-end" *ngIf="companyAdd">
      <label class="check-container">
        <input type="checkbox" (click)="selectDeselectUsers()" [checked]="isChecked">
        <span class="checkmark mt-3"></span>
      </label>
      <p class="pl-3 pt-3 text-select">select all</p>

      <div class="list-option pl-4"
        (click)="$event.stopPropagation();captureClick($event);openOptionDrawer = !openOptionDrawer"
        *ngIf="selectedUsers.length > 0 && (dropdownFlag || dropdownFlag2)">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div *ngIf="openOptionDrawer" class="drawer-container">
          <div>
            <p (click)="markAsAdmin()" *ngIf="dropdownFlag && !dropdownFlag2">Mark as Admin</p>
            <p (click)="removeAsAdmin()" *ngIf="dropdownFlag2 && !dropdownFlag">Remove as Admin</p>
          </div>
        </div>
      </div>
    </div>
  </div>



  <ng-container *ngIf="isLoadData">
    <div class="mt-3" *ngFor='let item of list  | paginate: { itemsPerPage: pageSize,
      currentPage: page,
      totalItems:totalCount }'>
      <list [list]='item' [displayType]="displayType.Active" (markUser)="markAsAdmin($event)"
        (removeUser)="removeAsAdmin($event)" (selectedStatus)="changeEmpStatus($event)"
        (selectedCheckBox)="getSelectedUser($event)" [checked]="checkboxValue"
        (dotClicked)="dotDropDownDetail=$event;openOptionDrawer=false" [checkPopupFlag]="dotDropDownDetail"></list>
    </div>
    <empty-state *ngIf="((list !== null && list?.length <= 0) || list === null)"></empty-state>
  </ng-container>
  <div class="pagination justify-content-center" style="margin-top: 20px;">
    <div class="d-flex  pagination-section" *ngIf="totalCount>=10">
      <div class="row d-flex pagination-border">
        <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChange($event)" nextLabel=""
          class="d-flex justify-content-center">
        </pagination-controls>
        <!-- <div class="pr-3 ratio-class pt-1" *ngIf="member?.length>=10">10/{{members?.list?.length}}</div> -->
        <div class="pr-3 ratio-class pt-1">
          {{page}}/{{(noPages)}}</div>
        <!-- <div class="pr-3 ratio-class pt-1">10/{{members?.list?.length}}</div> -->
      </div>
    </div>
  </div>

</div>